<template>
    <div class="app">
        <el-row>
            <el-col :span="18">
                <div class="search">
                    <el-form ref="form" :model="searchParams" label-width="80px">
                        <el-row>
                            <el-col :span="4">
                                <el-form-item label="团队名称">
                                    <el-input v-model="searchParams.name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="时间范围">
                                    <el-date-picker v-model="searchParams.time" type="daterange" range-separator="至"
                                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="支付状态">
                                    <select-option-dictionary v-model="searchParams.type"
                                        dkey="zf-state"></select-option-dictionary>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                                <el-button @click="clearSearchVal">清空</el-button>
                            </el-col>
                        </el-row>

                    </el-form>
                </div>
                <!-- <form action="">
        </form> -->
                <el-table :data="tableData" style="width: 100%">


                    <el-table-column prop="date" align="center" label="一级代理" width="550">

                        <el-table-column prop="onecount1" label="代理数" width="100">

                        </el-table-column>

                        <el-table-column prop="onedeal1" label="成交数" width="100">
                        </el-table-column>

                        <el-table-column prop="onecommition1" label="提成" width="100">
                        </el-table-column>
                    </el-table-column>

                    <el-table-column align="center" label="二级代理">

                        <el-table-column prop="onecount2" label="代理数" width="100">
                        </el-table-column>

                        <el-table-column prop="onedeal2" label="成交数" width="100">
                        </el-table-column>

                        <el-table-column prop="onecommition2" label="提成" width="100">
                        </el-table-column>
                    </el-table-column>


                    <el-table-column align="center" label="三级代理">

                        <el-table-column prop="onecount3" label="代理数" width="100">
                        </el-table-column>

                        <el-table-column prop="onedeal3" label="成交数" width="100">
                        </el-table-column>

                        <el-table-column prop="onecommition3" label="提成" width="100">
                        </el-table-column>
                    </el-table-column>

                    <el-table-column align="center" label="合计">

                        <el-table-column prop="waitCommission" label="待付提成" width="100">
                        </el-table-column>
                        <el-table-column prop="payCommission" label="已付提成" width="100">
                        </el-table-column>
                        <el-table-column prop="allCommission" label="总提成" width="145">
                        </el-table-column>

                    </el-table-column>
                </el-table>
                <div class="dataTable autoFlex" v-if="listData">
                    <el-table class="table" :data="listData" stripe row-key="id" border lazy height="300"
                        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
                        <el-table-column prop="name" width="230" label="代理名">
                        </el-table-column>
                        <el-table-column prop="moblie" width="230" label="手机号">
                        </el-table-column>
                        <el-table-column prop="cost"   label="提成金额">
                        </el-table-column>
                    </el-table>
                    <div class="pageBar">
                        <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
                            :page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
                            :page-sizes="this.$constant.page.pageSizes"></el-pagination>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <template>
                    <div id="main" style="width: 300px;height:250px;align"></div>
                </template>
            </el-col>
        </el-row>

    </div>
</template>


<script>
import * as echarts from 'echarts';
import api from '@/api/xueli/baobiao.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
export default {
    name: 'xiaoshou',
    components: {
       
        selectOptionDictionary
    },
    data() {
        return {
            searchParams: {},   // 查询参数
            tableData: [],  // 表格数据
            listData: [],       // 列表数据
            listLoading: false,
            page: new this.$constant.pageObj(),
        };
    },
    mounted() {
        this.list();
        this.drawChart();
    },
    methods: {
        drawChart() {
            
            //2. 基于准备好的dom，初始化echarts实例
            echarts
            var myChart = echarts.init(document.getElementById('main'));
            //3. 指定图表的配置项和数据
            var option = {
                title: {
                    text: '代理数'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['2级代理', '3级代理']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '2级代理',
                        type: 'line',
                        stack: 'Total',
                        data: [120, 132, 101, 134, 90, 230, 210]
                    },
                    {
                        name: '3级代理',
                        type: 'line',
                        stack: 'Total',
                        data: [220, 182, 191, 234, 290, 330, 310]
                    }]
            };//4.使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
        list() {
            this.listData = [];
            this.listLoading = true;
            let params = this.$utils.merger(this.searchParams, this.page);
            //获取销售代理头部数据
            api.xiaoshou({}, response => {
                this.tableData = response.data;
                console.log("头部表格tableData", response.data);
            });
            //根据搜索内容 获取列表数据
            api.list(params, response => {
                console.log("列表数据", response.data);
                this.listData = response.data.records;
            });
            this.listLoading = false;
        },
        //改变选择项
        // selectionChange(val) {
        //     //清空
        //     this.selected = [];
        //     for (let item of val) {
        //         this.selected.push(item);
        //     }
        // },
        //改变每页显示数量
        sizeChange(val) {
            this.page.size = val;
            this.list();
        },
        //改变现在的页码
        currentChange(val) {
            this.page.current = val;
            this.list();
        },
        //搜索
        search() {
            console.log(this.searchParams);
            this.list();
        },
        //清空搜索框
        clearSearchVal() {
            this.searchParams = {};
        }
    }
}
</script>